import {CircleHelp, MessageCircle, Smartphone, Wifi} from 'lucide-react';
import {VelaScene, type VelaRule} from '../engine/types';
import {CHAT_FAQ_CARD_ID} from './chat.rules';
import {CHAT_HOST_CARD_ID} from './registration.rules';

export const esimRules: VelaRule[] = [
  {
    id: 'esim/phone-must-support-it',
    section: 'goodToKnow',
    scenes: [VelaScene.Esim],
    priority: 30,
    evaluate: (_ctx, t) => ({
      id: 'esim-phone-support',
      icon: <Smartphone />,
      tone: 'warning',
      title: t('card.esim_phone_support.title'),
      description: t('card.esim_phone_support.body'),
    }),
  },
  {
    id: 'esim/install-before-you-fly',
    section: 'goodToKnow',
    scenes: [VelaScene.Esim],
    priority: 20,
    evaluate: (_ctx, t) => ({
      id: 'esim-install-early',
      icon: <Wifi />,
      title: t('card.esim_install_early.title'),
      description: t('card.esim_install_early.body'),
    }),
  },
  {
    id: 'esim/chat-host',
    section: 'quickActions',
    scenes: [VelaScene.Esim],
    priority: 20,
    evaluate: (ctx, t) =>
      ctx.isChatEnabled
        ? {
            id: CHAT_HOST_CARD_ID,
            icon: <MessageCircle />,
            title: t('card.chat_host.title'),
          }
        : null,
  },
  {
    id: 'esim/faq',
    section: 'quickActions',
    scenes: [VelaScene.Esim],
    priority: 10,
    evaluate: (ctx, t) =>
      ctx.isFaqEnabled
        ? {
            id: CHAT_FAQ_CARD_ID,
            icon: <CircleHelp />,
            title: t('card.chat_faq.title'),
            description: t('card.chat_faq.body'),
          }
        : null,
  },
];
